import React from 'react';
import Input from './input';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { IOption } from './selectInput';

interface InputWithUnitLabelProps {
  type: React.HTMLInputTypeAttribute;
  value: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  unitLabel?: string;
  min?: number;
  max?: number;
  step?: number;
  options?: IOption[];
  disabled?: boolean;
  error?: string;
  placeholder?: string;
}

function InputWithUnitLabel(props: InputWithUnitLabelProps) {
  const {
    type,
    value,
    handleChange,
    unitLabel,
    min,
    max,
    step,
    options,
    disabled,
    error,
    placeholder,
  } = props;
  return (
    <>
      <Input
        id="inputwithunitlabel-main"
        value={value || ''}
        inputType={type}
        options={options}
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        disabled={disabled}
        className="w-full border-0 disabled:bg-gray-100/80 focus:outline-none"
        title={error}
        placeholder={placeholder}
      />
      {!disabled && error ? (
        <div
          id="inputwithunitlabel-erroricon"
          className="bg-transparent mr-1"
          title={error}
        >
          <RMSvgIcon id='inputwithunitlabel-svg-error-icon' name="Error" fill="red" className="w-4 h-4 !bg-transparent" />
        </div>
      ) : null}
      {unitLabel ? (
        <div
          id="inputwithunitlabel-unitlabel"
          className="bg-gray-200 w-8 text-center border h-full"
        >
          <span id={`inputwithunitlabel-${unitLabel}-content`} className="text-sm">{unitLabel}</span>
        </div>
      ) : null}
    </>
  );
}

export default InputWithUnitLabel;
